module.exports = __webpack_public_path__ + "static/restaurant_rokuza01-103fc9e81900f7b3331d77558b3c29b9.jpg";